"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDestPlane = void 0;
var getDestPlane = function (config) {
    return config.yAxis.right ? [
        [
            [config.xAxis.marginStart, config.height - config.yAxis.marginEnd],
            [config.width - config.xAxis.marginEnd, config.height - config.yAxis.marginEnd],
        ],
        [
            [config.width - config.xAxis.marginEnd, config.height - config.yAxis.marginEnd],
            [config.width - config.xAxis.marginEnd, config.yAxis.marginStart]
        ]
    ] : [
        [
            [config.xAxis.marginStart, config.height - config.yAxis.marginEnd],
            [config.width - config.xAxis.marginEnd, config.height - config.yAxis.marginEnd],
        ],
        [
            [config.xAxis.marginStart, config.height - config.yAxis.marginEnd],
            [config.xAxis.marginStart, config.yAxis.marginStart]
        ]
    ];
};
exports.getDestPlane = getDestPlane;
